//recipeId, orgamizationId
import { struct } from 'io-ts/Decoder';

import { WholeHouseId as WholeHouseAncillaryItemId } from '../../../job/ancillary-item';
import { Id as TransactionId } from '../../../transaction/Id';

export const Request = struct({
	transactionId: TransactionId,
	takeoffType: WholeHouseAncillaryItemId,
});
